import type { SVGProps } from 'react'
const SvgSyBookCheck = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={16} height={18} x={4} y={3} fillOpacity={0.24} rx={2} />
		<path d="M4 19a2 2 0 0 1 2-2h11c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C20 15.398 20 14.932 20 14v3c0 1.886 0 2.828-.586 3.414S17.886 21 16 21H6a2 2 0 0 1-2-2M15.076 8.076 11.5 11.65l-1.576-1.574-.848.848 1.893 1.894a.76.76 0 0 0 1.062 0l3.893-3.894z" />
	</svg>
)
export default SvgSyBookCheck
